import { CardInfoActions } from '../+state/card-info.actions';
import { tassign } from 'tassign';
import { RidangoReduxAction } from '@ridango/core';
import { CardBalance } from '@ridango/core';

// TODO: revisit data types
export interface CardInfoState {
    card_number: string;
    balance: CardBalance;
    start_date: any;
    end_date: any;
    tickets: any[];
    history: any[];
    loading: boolean;

}
export const CARD_INFO_INITIAL_STATE: CardInfoState = {
    card_number: null,
    balance: null,
    start_date: null,
    end_date: null,
    tickets: [],
    history: [],
    loading: false
};

export function cardInfoReducer ( lastState: CardInfoState = CARD_INFO_INITIAL_STATE, action: RidangoReduxAction ): CardInfoState {
    switch ( action.type ) {
        case CardInfoActions.SET_CARD_NUMBER:
            return tassign( lastState, { card_number: action.payload } );
        case CardInfoActions.SET_CARD_BALANCE:
            return tassign( lastState, { balance: action.payload } );
        case CardInfoActions.SET_CARD_TICKETS:
            return tassign( lastState, { tickets: action.payload } );
        case CardInfoActions.SET_FROM_DATE:
            return tassign( lastState, { start_date: action.payload } );
        case CardInfoActions.SET_TO_DATE:
            return tassign( lastState, { end_date: action.payload } );
        case CardInfoActions.SET_CARD_HISTORY:
            return tassign( lastState, { history: action.payload } );
        case CardInfoActions.SET_CARD_INFO_LOADING:
            return tassign( lastState, { loading: action.payload } );
    }
    return lastState;
}
